/**
 * This will turn an element into a slideshow that transitions smoothly between slides using
 * `transform: translateX(...)`.
 *
 * Ensure that the container of the slides either has `overflow-x: hidden`.
 *
 * @param slideSpeed <integer> time (ms) between slides
 * @param animationSpeed <integer> time (ms) it takes for the animation to complete
 * @param rootClass <string> class of the root element
 * @param multi <boolean> whether multiple slides are shown at once
 * @param pauseOnHover <boolean> whether to pause when mouse hovers over container
 */
jQuery.fn.slides = function({
  slideSpeed = 5000,
  animationSpeed = 400,
  rootClass = 'slides',
  multi = false,
  pauseOnHover = false,
}) {
  let slidePosition = 0
  let timeout;
  const container = $(this)
  const slideClass = `${rootClass}__slide`
  const dotClass = `${rootClass}__dot`
  const selectedDotClass = `${dotClass}--selected`
  const numberOfSlides = container.find(`.${slideClass}`).length

  function handleDotClick(idx) {
    setSlidePosition(idx)

    container
      .find(`.${selectedDotClass}`)
      .removeClass(selectedDotClass)

    container
      .find(`.${dotClass}:nth-child(${idx + 1})`)
      .addClass(selectedDotClass)

    if (!pauseOnHover) {
      clearTimeout(timeout)
      timeout = setTimeout(() => nextSlide(), slideSpeed)
    }
  }

  function setSlidePosition(position) {
    slidePosition = position

    container
      .find(`.${slideClass}`)
      .css('transform', `translateX(${-position * 100}%`)
  }

  function resetPosition() {
    slidePosition = 0

    container
      .find(`.${slideClass}`)
      .css('transition', 'initial')
      .css('transform', 'translateX(0)')

    setTimeout(() => {
      container
        .find(`.${slideClass}`)
        .css('transition', `transform ${animationSpeed}ms`)
    }, 100)
  }

  function nextSlide() {
    // Increment slider position
    setSlidePosition(slidePosition + 1)

    // Loop this function
    clearTimeout(timeout)
    timeout = setTimeout(() => nextSlide(), slideSpeed)

    // Has got to the end of the slides
    const hasLooped = numberOfSlides === slidePosition

    if (hasLooped) {
      container
        .find(`.${selectedDotClass}`)
        .removeClass(selectedDotClass)

      container
        .find(`.${dotClass}`)
        .first()
        .addClass(selectedDotClass)

      setTimeout(() => resetPosition(), animationSpeed)
    } else {
      container
        .find(`.${selectedDotClass}`)
        .removeClass(selectedDotClass)
        .next()
        .addClass(selectedDotClass)
    }
  }

  function initialiseSliders() {
    // Set the correct transition speed
    container
      .find(`.${slideClass}`)
      .css('transition', `transform ${animationSpeed}ms`)

    const slides = container.find(`.${slideClass}`)
    const firstSlide = slides.first()

    if (multi) {
      // Clone first to last of slides parent
      slides
        .clone()
        .addClass(`${rootClass}__slide--extra`)
        .appendTo(firstSlide.parent())
    } else {
      // Clone first to last of slides parent
      firstSlide
        .clone()
        .appendTo(firstSlide.parent())
    }

    if (pauseOnHover) {
      container.on('mouseover', () => { clearTimeout(timeout) })
        .on('mousemove', () => { clearTimeout(timeout) })
        .on('mouseout', () => {
          timeout = setTimeout(() => nextSlide(), slideSpeed)
        })
    }

    // Add selected modifier to first dot
    container.find(`.${dotClass}`)
      .first()
      .addClass(selectedDotClass)

    // Handle dot clicks
    container.find(`.${dotClass}`)
      .each(function(idx) {
        $(this).on('click', () => handleDotClick(idx))
      })
  }

  const hasMoreThanOneSlides = container.find(`.${slideClass}`).length > 1

  if (hasMoreThanOneSlides) {
    initialiseSliders()

    // Begin slide transitions
    timeout = setTimeout(() => nextSlide(), slideSpeed)
  }
}



// WEBPACK FOOTER //
// ./scripts/slider.js